import { render, staticRenderFns } from "./LoginSso.vue?vue&type=template&id=4f497535&scoped=true&"
import script from "./LoginSso.vue?vue&type=script&lang=js&"
export * from "./LoginSso.vue?vue&type=script&lang=js&"
import style0 from "./LoginSso.vue?vue&type=style&index=0&id=4f497535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f497535",
  null
  
)

export default component.exports